import * as React from 'react'
import { connect } from 'react-redux'
import { PhoneSystemExtensionEditFormComponent } from './PhoneSystemExtensionEditForm'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const formName = 'phoneSystemExtensionEdit'

export interface IExtensionFormData {
  phoneSystemId: string
  extensionId: string
  name: string
  number: string
  displayNumber: string
}

export interface IPhoneSystemExtensionEditFormProps {
  onAfterSubmit: () => undefined
  initialValues?: IExtensionFormData
  didNumbers: any
  isAdmin?: boolean
}

const stateToProps = ({ auth }) => ({
  isAdmin: (auth.user.roles && auth.user.roles.includes('ROLE_API_ADMIN')) || auth.adminToken,
})
const dispatchToProps = {}

export const PhoneSystemExtensionEditForm = flow<
  any,
  any,
  React.SFC<IPhoneSystemExtensionEditFormProps>
>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(PhoneSystemExtensionEditFormComponent)



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemExtensionEditForm/PhoneSystemExtensionEditForm.container.ts